<template>
  <div>
    <Head title="Landed Costs Entries" />
    <h1 class="mb-8 text-3xl font-bold"><Link class="text-orange-600 hover:text-orange-500" href="/landed-costs">Landed Costs: {{ landedCost.date }}</Link></h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <a class="btn-orange hidden" href="#" @click="openUploadWindow">
        <span>Upload</span>
        <span class="hidden md:inline">&nbsp;Landed Costs</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3">Category</th>
          <th class="pb-3 pt-3 px-3">Cost</th>
          <th class="pb-3 pt-3 px-3" />
        </tr>
        <tr v-for="item in landedCosts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" href="#" @click="editEntry(item)">
              {{ item.part_number }}
            </a>
          </td>
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" href="#" @click="editEntry(item)">
              {{ item.description }}
            </a>
          </td>
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" href="#" @click="editEntry(item)">
              {{ item.category }}
            </a>
          </td>
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" href="#" @click="editEntry(item)">
              {{ item.cost }}
            </a>
          </td>
          <td class="w-px border-t">
            <a
              v-if="user.group_permissions.includes('add_landed_costs')
                || user.per_user_permissions.includes('add_landed_costs')"
              class="flex items-center px-3" href="#" tabindex="-1" @click="deleteEntry(item)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="landedCosts.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="landedCosts.links" />
  </div>
  <div v-if="openEdit" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white w-1/2 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">Update {{ selectedItem.part_number }}</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form enctype="multipart/form-data" @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-8 pr-8 pb-8">
                  <text-input v-model="formData.cost" class="pb-8 pr-6 w-full lg:w-full" label="Cost" />
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="update">
                Update
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openDelete" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white w-1/2 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">Delete {{ selectedItem.part_number }}</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-4 pl-2 pr-2 pb-8">
                  <p>You are about to delete {{ selectedItem.part_number }} from {{ landedCost.date }} landed costs, do you wish to continue?</p>
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="deleteItem">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'
    
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    landedCosts: Object,
    landedCost: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      formData: {
        cost: null,
      },
      openEdit: false,
      openDelete: false,
      selectedItem: null,
      checkSuccess: false,
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/landed-cost/${this.landedCost.id}/landed-cost-entries`, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    openEditWindow() {
      this.openEdit = true
    },
    closeModal() {
      this.openEdit = false
      this.openDelete = false
    },
    editEntry(item) {
      if (this.user.group_permissions.includes('add_landed_costs')
          || this.user.per_user_permissions.includes('add_landed_costs'))
      {
        this.selectedItem = item
        this.formData.cost = item.cost
        this.openEdit = true
      }
    },
    deleteEntry(item) {
      this.selectedItem = item
      this.openDelete = true
    },
    update() {
      this.formData._method = 'put'
      this.formData.id = this.landedCost.id
      this.$inertia.post(`/landed-cost/${this.landedCost.id}/landed-cost-entries/${this.selectedItem.id}`, this.formData, {
        onSuccess: () => {
          this.openEdit = false
        },
      })
    },
    deleteItem() {
      this.formData._method = 'post'
      this.formData.id = this.landedCost.id
      this.$inertia.delete(`/landed-cost/${this.landedCost.id}/landed-cost-entries/${this.selectedItem.id}`, this.formData, {
        onSuccess: () => {
          this.checkSuccess = true
        },
        onError: () => {
          this.checkSuccess = false
        },
      })
      this.openDelete = false
    },
  },
}
</script>
      